var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checkOriginUrl)?_c('iframe',{ref:"iframe",staticClass:"frame",attrs:{"data-originurl":_vm.dataOriginUrl,"src":_vm.src,"data-aditional-params":_vm.additionalParams,"id":"seven-plugin-live","data-type":_vm.isMobile ? 'mobile' : 'desktop',"scrolling":"no","frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da3909d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/games/virtuals/components/Game.vue
// module id = 2193
// module chunks = 0